import { render, staticRenderFns } from "./ProductsSelector.vue?vue&type=template&id=1ba91fd8&scoped=true&"
import script from "./ProductsSelector.vue?vue&type=script&lang=js&"
export * from "./ProductsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba91fd8",
  null
  
)

export default component.exports